import PageLoader from '@/app/common/components/PageLoader/PageLoader'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout'
import { useGetExpenseCategories } from '@/app/pages/providers/api/usePaymentProviders'
import { SelectExpenseCategoriesForm, TExpenseForm } from '@/app/pages/providers/pages/select_expense_categories/select_expense_categories-form'
import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'

type Props = {
  onNext: (data: TExpenseForm) => void
  defaultValues: TExpenseForm
}

function ReimbursementSelectCategoriesPage(props: Props) {
  const {onNext, defaultValues} = props
  const navigate = useNavigate()


  const query = useGetExpenseCategories({
    reimbursement: 1,
  })



  function onSubmit(data: TExpenseForm) {
    onNext(data)
  }



  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>Select Categories</FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className='w-full'>
          <PageLoader query={query}>
            {(expenses) => (
            <SelectExpenseCategoriesForm
              defaultValues={defaultValues}
              invoiceLabel={t("po_number")}
                expenses={expenses}
              onBack={() => navigate(-1)}
              onSubmit={onSubmit}
              />
            )}
        </PageLoader>
      </FamilyWizardLayout.Content>
    </FamilyWizardLayout>
  )
}

export default ReimbursementSelectCategoriesPage
